// Sends checkout telemetry to the backend (POST /checkout_events) so
// client-side failures show up in the falcon admin checkout events log
// next to the server-side ones. Every call is fire-and-forget and
// swallows its own errors: tracking must never break a checkout.

const ENDPOINT = "/checkout_events";

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content;
}

function detectFlow() {
  return window.location.pathname.startsWith("/shop") ? "shop" : "course";
}

export function trackCheckoutEvent(
  event,
  { severity = "info", message = null, context = {}, orderUid = null, flow = detectFlow() } = {}
) {
  try {
    const headers = { "Content-Type": "application/json" };
    const token = csrfToken();
    if (token) headers["X-CSRF-Token"] = token;

    return fetch(ENDPOINT, {
      method: "POST",
      headers,
      body: JSON.stringify({ event, severity, message, context, order_uid: orderUid, flow }),
      credentials: "same-origin",
      keepalive: true,
    }).catch(() => {});
  } catch {
    return Promise.resolve();
  }
}

let captureInstalled = false;

// Reports uncaught JS errors and unhandled promise rejections that happen
// while the user is on a checkout page.
export function installCheckoutErrorCapture({ orderUid = null, flow = detectFlow() } = {}) {
  if (captureInstalled) return;
  captureInstalled = true;

  window.addEventListener("error", (e) => {
    trackCheckoutEvent("client_js_error", {
      severity: "error",
      message: e.message,
      context: { filename: e.filename, lineno: e.lineno, colno: e.colno },
      orderUid,
      flow,
    });
  });

  window.addEventListener("unhandledrejection", (e) => {
    const reason = e.reason;
    trackCheckoutEvent("client_unhandled_rejection", {
      severity: "error",
      message: (reason && reason.message) || String(reason),
      orderUid,
      flow,
    });
  });
}
